import type * as Types from '../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { IdentityFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/identity.graphql';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/share-class.graphql';
import { StFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/share-transaction.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCreateTransactionQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlSellableSharesInput;
  shInput: Types.GqlShSellableSharesInput;
  fetchShState: Types.Scalars['Boolean']['input'];
}>;


export type GqlCreateTransactionQuery = { shareClasses: Array<{ name: string, voteWeight: string }>, nextShareCapitalChanges: { afterNext?: { id: string } | null }, shCount: { count: number }, companySubscription?: { mainProduct: string, isActive: boolean } | null, shareholders: Array<{ id: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }>, shSellableShares?: { sellableShares: { shares: any, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null }> } }, sellableShareState: { shareRegisterIsValid: boolean, sellableShares: Array<{ shares: any, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null }>, shareholder: { id: string, companyId: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } } }> } };

export type GqlStCreateTransferMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlStCreateTransferInput;
}>;


export type GqlStCreateTransferMutation = { stCreateTransfer: { deletedIds: Array<string>, createdSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, updatedSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, deletedStgs?: Array<{ id: string }> | null } };

export type GqlStCreateShareClassConvertMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlStCreateTransferInput;
}>;


export type GqlStCreateShareClassConvertMutation = { stCreateTransfer: { deletedIds: Array<string>, createdSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, updatedSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, deletedStgs?: Array<{ id: string }> | null } };

export type GqlStCreateIssueMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlStCreateIssueInput;
}>;


export type GqlStCreateIssueMutation = { stCreateIssue: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }> };

export type GqlStCreateUnissueMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlStCreateUnissueInput;
}>;


export type GqlStCreateUnissueMutation = { stCreateUnissue: { deletedIds: Array<string>, createdSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, updatedSts: Array<{ blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null }>, deletedStgs?: Array<{ id: string }> | null } };


export const CreateTransactionDocument = gql`
    query CreateTransaction($companyId: ID!, $input: SellableSharesInput!, $shInput: ShSellableSharesInput!, $fetchShState: Boolean!) {
  shareClasses(companyId: $companyId) {
    name
    voteWeight
  }
  nextShareCapitalChanges(companyId: $companyId) {
    afterNext {
      id
    }
  }
  shCount(companyId: $companyId) {
    count
  }
  companySubscription(companyId: $companyId) {
    mainProduct
    isActive
  }
  shareholders(companyId: $companyId) {
    id
    identity {
      ...IdentityFields
    }
  }
  shSellableShares(companyId: $companyId, input: $shInput) @include(if: $fetchShState) {
    sellableShares {
      shares
      shareClasses {
        ...ScFields
      }
    }
  }
  sellableShareState(companyId: $companyId, input: $input) {
    shareRegisterIsValid
    sellableShares {
      shares
      shareClasses {
        ...ScFields
      }
      shareholder {
        id
        companyId
        identity {
          ...IdentityFields
        }
      }
    }
  }
}
    ${IdentityFieldsFragmentDoc}
${ScFieldsFragmentDoc}`;

/**
 * __useCreateTransactionQuery__
 *
 * To run a query within a React component, call `useCreateTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateTransactionQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      shInput: // value for 'shInput'
 *      fetchShState: // value for 'fetchShState'
 *   },
 * });
 */
export function useCreateTransactionQuery(baseOptions: Apollo.QueryHookOptions<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables> & ({ variables: GqlCreateTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>(CreateTransactionDocument, options);
      }
export function useCreateTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>(CreateTransactionDocument, options);
        }
export function useCreateTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>(CreateTransactionDocument, options);
        }
export type CreateTransactionQueryHookResult = ReturnType<typeof useCreateTransactionQuery>;
export type CreateTransactionLazyQueryHookResult = ReturnType<typeof useCreateTransactionLazyQuery>;
export type CreateTransactionSuspenseQueryHookResult = ReturnType<typeof useCreateTransactionSuspenseQuery>;
export type CreateTransactionQueryResult = Apollo.QueryResult<GqlCreateTransactionQuery, GqlCreateTransactionQueryVariables>;
export const StCreateTransferDocument = gql`
    mutation StCreateTransfer($companyId: ID!, $input: StCreateTransferInput!) {
  stCreateTransfer(companyId: $companyId, input: $input) {
    deletedIds
    createdSts {
      ...StFields
    }
    updatedSts {
      ...StFields
    }
    deletedStgs {
      id
    }
  }
}
    ${StFieldsFragmentDoc}`;
export type GqlStCreateTransferMutationFn = Apollo.MutationFunction<GqlStCreateTransferMutation, GqlStCreateTransferMutationVariables>;

/**
 * __useStCreateTransferMutation__
 *
 * To run a mutation, you first call `useStCreateTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStCreateTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stCreateTransferMutation, { data, loading, error }] = useStCreateTransferMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStCreateTransferMutation(baseOptions?: Apollo.MutationHookOptions<GqlStCreateTransferMutation, GqlStCreateTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStCreateTransferMutation, GqlStCreateTransferMutationVariables>(StCreateTransferDocument, options);
      }
export type StCreateTransferMutationHookResult = ReturnType<typeof useStCreateTransferMutation>;
export type StCreateTransferMutationResult = Apollo.MutationResult<GqlStCreateTransferMutation>;
export type StCreateTransferMutationOptions = Apollo.BaseMutationOptions<GqlStCreateTransferMutation, GqlStCreateTransferMutationVariables>;
export const StCreateShareClassConvertDocument = gql`
    mutation StCreateShareClassConvert($companyId: ID!, $input: StCreateTransferInput!) {
  stCreateTransfer(companyId: $companyId, input: $input) {
    deletedIds
    createdSts {
      ...StFields
    }
    updatedSts {
      ...StFields
    }
    deletedStgs {
      id
    }
  }
}
    ${StFieldsFragmentDoc}`;
export type GqlStCreateShareClassConvertMutationFn = Apollo.MutationFunction<GqlStCreateShareClassConvertMutation, GqlStCreateShareClassConvertMutationVariables>;

/**
 * __useStCreateShareClassConvertMutation__
 *
 * To run a mutation, you first call `useStCreateShareClassConvertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStCreateShareClassConvertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stCreateShareClassConvertMutation, { data, loading, error }] = useStCreateShareClassConvertMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStCreateShareClassConvertMutation(baseOptions?: Apollo.MutationHookOptions<GqlStCreateShareClassConvertMutation, GqlStCreateShareClassConvertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStCreateShareClassConvertMutation, GqlStCreateShareClassConvertMutationVariables>(StCreateShareClassConvertDocument, options);
      }
export type StCreateShareClassConvertMutationHookResult = ReturnType<typeof useStCreateShareClassConvertMutation>;
export type StCreateShareClassConvertMutationResult = Apollo.MutationResult<GqlStCreateShareClassConvertMutation>;
export type StCreateShareClassConvertMutationOptions = Apollo.BaseMutationOptions<GqlStCreateShareClassConvertMutation, GqlStCreateShareClassConvertMutationVariables>;
export const StCreateIssueDocument = gql`
    mutation StCreateIssue($companyId: ID!, $input: StCreateIssueInput!) {
  stCreateIssue(companyId: $companyId, input: $input) {
    ...StFields
  }
}
    ${StFieldsFragmentDoc}`;
export type GqlStCreateIssueMutationFn = Apollo.MutationFunction<GqlStCreateIssueMutation, GqlStCreateIssueMutationVariables>;

/**
 * __useStCreateIssueMutation__
 *
 * To run a mutation, you first call `useStCreateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStCreateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stCreateIssueMutation, { data, loading, error }] = useStCreateIssueMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStCreateIssueMutation(baseOptions?: Apollo.MutationHookOptions<GqlStCreateIssueMutation, GqlStCreateIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStCreateIssueMutation, GqlStCreateIssueMutationVariables>(StCreateIssueDocument, options);
      }
export type StCreateIssueMutationHookResult = ReturnType<typeof useStCreateIssueMutation>;
export type StCreateIssueMutationResult = Apollo.MutationResult<GqlStCreateIssueMutation>;
export type StCreateIssueMutationOptions = Apollo.BaseMutationOptions<GqlStCreateIssueMutation, GqlStCreateIssueMutationVariables>;
export const StCreateUnissueDocument = gql`
    mutation StCreateUnissue($companyId: ID!, $input: StCreateUnissueInput!) {
  stCreateUnissue(companyId: $companyId, input: $input) {
    deletedIds
    createdSts {
      ...StFields
    }
    updatedSts {
      ...StFields
    }
    deletedStgs {
      id
    }
  }
}
    ${StFieldsFragmentDoc}`;
export type GqlStCreateUnissueMutationFn = Apollo.MutationFunction<GqlStCreateUnissueMutation, GqlStCreateUnissueMutationVariables>;

/**
 * __useStCreateUnissueMutation__
 *
 * To run a mutation, you first call `useStCreateUnissueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStCreateUnissueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stCreateUnissueMutation, { data, loading, error }] = useStCreateUnissueMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStCreateUnissueMutation(baseOptions?: Apollo.MutationHookOptions<GqlStCreateUnissueMutation, GqlStCreateUnissueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStCreateUnissueMutation, GqlStCreateUnissueMutationVariables>(StCreateUnissueDocument, options);
      }
export type StCreateUnissueMutationHookResult = ReturnType<typeof useStCreateUnissueMutation>;
export type StCreateUnissueMutationResult = Apollo.MutationResult<GqlStCreateUnissueMutation>;
export type StCreateUnissueMutationOptions = Apollo.BaseMutationOptions<GqlStCreateUnissueMutation, GqlStCreateUnissueMutationVariables>;